export default {
    setAuthenticatedUser: (state, param) => {
        const {payload} = param;
        state.data = payload
    },
}
